
define('text!modules/home/sidebar/templates/following.filters.template.html',[],function () { return '<option value="1">Current %followingType%s</option>\r\n<option value="2">Past %followingType%s</option>\r\n<option value="3">Current & Past %followingType%s</option>\r\n<option value="0">%followingType% Filter Off</option>';});

